import React from "react";
import { Workflow, BCMSDate, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import { Transaction ,LinkedAccount} from "model";
import AutopayPage from "components/pages/AutopayPage";
import ActivatedAutopayView from "components/pages/AutopayPage/components/ActivatedAutopayView";
import EnterAutopayView from "components/pages/AutopayPage/components/EnterAutopayView";



const steps = [<AutopayPage view={<EnterAutopayView/>} ></AutopayPage>,
<AutopayPage view={<ActivatedAutopayView/>} ></AutopayPage>];

/**
 * @function AutoPayWorkFlow
 * @returns {React.Component}
 * @description The main component for the dispute transaction workflow.
 * @exported true
 * @example <DisputeTransactionWorkflow />
 */
export default function AutoPayWorkFlow(props) {
    const globalController = useBCMSContext();
 
    BCMSRecord.globalControllerFor([ LinkedAccount,Transaction ], globalController);
    const transactionID = useParams().transactionID ?? "0";
    const value = getDefault(globalController, transactionID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the dispute transaction
 */
export const getDefault = (controller, transactionID) => {
   
 

    return {
        date: undefined,
        amountSelect: undefined,
        account: LinkedAccount.initByID("0"),
        card:undefined,
        amount:undefined
      
    }
};